/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;
  var urlParams = new URLSearchParams(window.location.search);
  var action = urlParams.get('action');
  var nama = "";

  var openUpdate = function openUpdate() {
    $(".card-update").show();
    $(".card-logout").hide();
  };

  var closeUpdate = function closeUpdate() {
    $(".card-update").hide();
    $(".card-logout").show();
  };

  var closeChange = function closeChange() {
    $(".card-forgot").hide();
    $(".card-login").show();
  };

  var openCreate = function openCreate() {
    $(".card-new").show();
    $(".card-logout").hide();
    $(".card-login").hide();
    $f7.popup.close(".rfx-popup");
  };

  var closeCreate = function closeCreate() {
    $(".card-new").hide();
    $(".card-logout").hide();
    $(".card-login").show();
  };

  var openForgot = function openForgot() {
    $(".card-forgot").show();
    $(".card-logout").hide();
    $(".card-login").hide();
  };

  var accountInfo = function accountInfo() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/account.php?action=get',
      data: {
        Email: localStorage.getItem("Email")
      },
      success: function success(data) {
        console.log("Output:" + data);

        if (data == "null") {
          $("#UpdateName").val("");
          $("#UpdateEmail").val("");
          $("#UpdatePhone").val("");
          $("#UpdateBankName").val("");
          $("#UpdateBankAccount").val("");
          $('.DisplayName').html("@guest");
          $('.DisplayNick').html("@guest");
          $('.DisplayPhone').html("");
          $('.DisplayAccountNo').html("");
          $(".card-new").hide();
          $(".card-update").hide();
          $(".card-login").show();
          $(".card-forgot").hide();
          $(".card-logout").hide();
          return;
        } else {
          $(".card-new").hide();
          $(".card-update").hide();
          $(".card-login").hide();
          $(".card-forgot").hide();
          $(".card-logout").show();
        }

        data = JSON.parse(data);

        if (data.Phone != "") {
          $("#UpdateName").val(data.Name);
          $("#UpdateEmail").val(data.Email);
          $("#UpdatePhone").val(data.Phone);
          $("#UpdateBankName").val(data.BankName);
          $("#UpdateBankAccount").val(data.BankAccount);
          $('.DisplayName').html(data.Name);
          $('.DisplayNick').html("@" + data.Email.split("@")[0]);
          $('.DisplayPhone').html(data.AccountNumber); //$('.DisplayAccountNo').html(localStorage.getItem("AccountName"));

          localStorage.setItem("Name", data.Name);
          localStorage.setItem("Phone", data.Phone);
          localStorage.setItem("Email", data.Email); //localStorage.setItem("AccountNumber",data.AccountNumber);

          localStorage.setItem("BankName", data.BankName);
          localStorage.setItem("BankAccount", data.BankAccount);
          window.checkNow = true;
          window.checkNowHistory = true;
          nama = data.Name.charAt(0); //$f7.tab.show("#view-home", true);

          if (data.Type == "admin") {
            window.control = true;
            localStorage.setItem("control", "true");
            $(".control").show();
          }

          $update();
        }
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var logout = function logout() {
    $('#LoginEmail').val("");
    $('#LoginPassword').val("");
    $(".control").hide();
    localStorage.clear();
    window.checkNow = true;
    window.checkNowHistory = true;
    accountInfo();
  };

  var toastIcon;

  var showToastIcon = function showToastIcon() {
    // Create toast
    if (!toastIcon) {
      toastIcon = $f7.toast.create({
        icon: '<i class="f7-icons">checkmark_alt</i>',
        text: 'Logged In',
        position: 'center',
        closeTimeout: 2000
      });
    } // Open it


    toastIcon.open();
  };

  var change_stock = function change_stock() {
    console.log($("#change_stock").val());
    localStorage.setItem("AccountNumber", $("#change_stock").val());
    accountInfo();
  };

  var login = function login() {
    if ($('#LoginEmail').val() == "" || $('#LoginPassword').val() == "") {
      $f7.dialog.alert("Email or password is empty");
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/account.php?action=login',
      data: {
        Email: $('#LoginEmail').val(),
        Password: $('#LoginPassword').val()
      },
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);

        if (data.status == 1) {
          showToastIcon();
          localStorage.setItem("Email", $('#LoginEmail').val());
          console.log($("#select_stock").val());
          localStorage.setItem("AccountNumber", $("#select_stock").val());
          $("#change_stock").val(localStorage.getItem("AccountNumber"));
          accountInfo();
          $(".button-login").html("Close");
          $(".button-register").hide();
        } else {
          $f7.dialog.alert(data.errMsg, "Login Failed");
        }
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var changePasswordOTP = function changePasswordOTP() {
    if ($('#PhoneChange').val() == "" || $('#PasswordChange').val() == "") {
      $f7.dialog.alert("Please fill in all input fields");
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/otp_email.php',
      data: {
        phone: $('#PhoneChange').val(),
        email: $('#PhoneChange').val()
      },
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);
        $f7.dialog.prompt('An OTP is sent to your email. Please enter the OTP number', function (TAC) {
          if (TAC == data.otp) {
            changePassword();
          } else {
            $f7.dialog.alert("Wrong TAC number please try again");
          }
        });
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var changePassword = function changePassword() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/account.php?action=forgot_password',
      data: {
        Phone: $('#PhoneChange').val(),
        Password: $('#PasswordChange').val()
      },
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);

        if (data.status == 1) {
          $f7.dialog.alert("You have successfully change your password", "Password changed");
          $('#PhoneChange').val("");
          $('#PasswordChange').val("");
          closeChange();
        } else {
          $f7.dialog.alert(data.errMsg, "Password change failed");
        }
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var createAccountOTP = function createAccountOTP() {
    if ($('#Name').val() == "" || $('#Phone').val() == "" || $('#Email').val() == "" || $('#Password').val() == "") {
      $f7.dialog.alert("Please fill in all input fields");
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/otp_email.php',
      data: {
        email: $('#Email').val()
      },
      success: function success(data) {
        //console.log("Output:" + data);
        data = JSON.parse(data);
        $f7.dialog.prompt('An OTP is sent to your email. Please enter the OTP number', function (TAC) {
          if (TAC == data.otp) {
            createAccount();
          } else {
            $f7.dialog.alert("Wrong TAC number please try again");
          }
        });
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var createAccount = function createAccount() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/account.php?action=new',
      data: {
        Name: $('#Name').val(),
        Email: $('#Email').val(),
        Phone: $('#Phone').val(),
        Password: $('#Password').val()
      },
      success: function success(data) {
        //console.log("Output:" + data);
        data = JSON.parse(data);

        if (data.status == 1) {
          $f7.dialog.alert("You have successfully create an account", "Account Created");
          localStorage.setItem("Email", $('#Email').val());
          localStorage.setItem("Account", $('#AccountNumber').val());
          localStorage.setItem("AccountNumber", $("#select_stock").val());
          $("#change_stock").val(localStorage.getItem("AccountNumber"));
          accountInfo();
        } else {
          $f7.dialog.alert(data.errMsg, "Create Account Failed");
        }
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var updateAccount = function updateAccount() {
    if ($('#UpdateName').val() == "" || $('#UpdateEmail').val() == "") {
      $f7.dialog.alert("Please fill in all input fields");
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/account.php?action=update',
      data: {
        Name: $('#UpdateName').val(),
        Email: $('#UpdateEmail').val(),
        Phone: $('#UpdatePhone').val(),
        BankName: $('#UpdateBankName').val(),
        BankAccount: $('#UpdateBankAccount').val()
      },
      success: function success(data) {
        //console.log("Output:" + data);
        data = JSON.parse(data);

        if (data.status == 1) {
          $f7.dialog.alert("You have successfully update your account", "Account Updated");
          accountInfo();
        } else {
          if (data.errMsg == "") {
            $f7.dialog.alert("No Change");
          } else {
            $f7.dialog.alert(data.errMsg, "Update Account Failed");
          }
        }
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var getTest = function getTest() {
    $f7.request({
      method: 'get',
      url: 'https://myptptnstg.ptptn.gov.my/campaign/games/take/930302095131/JOZQwagTY7PLWjsX5ak6594mOtz7lRNs5p8jC34I2NVW6hVgXHQtVXLLS8Ck',
      success: function success(data) {
        console.log("Output:" + data);
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var getStock = function getStock() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/account.php?action=get_stock',
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);
        var select_stock = "";

        for (var i = 0; i < data.length; i++) {
          if (i == 0) window.account = data[i].AccountNumber;
          var selected = "";
          if (data[i].AccountName == localStorage.getItem("stock")) selected = "selected";
          select_stock += "<option value='" + data[i].AccountNumber + "' " + selected + ">" + data[i].AccountName + "</option>";
        }

        $("#select_stock").html(select_stock);
        $("#change_stock").html(select_stock);

        if (localStorage.getItem("AccountNumber") != null) {
          $("#change_stock").val(localStorage.getItem("AccountNumber"));
        }
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  $on('pageInit', function () {
    console.log("THE STOCK:" + localStorage.getItem("stock"));
    accountInfo();
    getStock();
    $(".version").html(window.version);

    if (localStorage.getItem("AccountNumber") == null) {
      $f7.toolbar.hide(".toolbar-bottom");
      $f7.tab.show("#view-account", false); //$(".navbar").hide();
    } else {
      $f7.toolbar.show(".toolbar-bottom");
      $(".button-login").html("Close");
      $(".button-register").hide(); //$(".navbar").show();
    }

    setInterval(function () {
      if (localStorage.getItem("AccountNumber") == null) {
        $f7.toolbar.hide(".toolbar-bottom");
        $f7.tab.show("#view-account", false); //$(".navbar").hide();
      } else {
        $f7.toolbar.show(".toolbar-bottom"); //$(".navbar").show();
      }
    }, 100);
    $f7.tab.show("#view-account", false);
    setTimeout(function () {
      if (action == "create") {
        openCreate();
        console.log("OPEN CREATE");
      }
    }, 100);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="settings">

      <!-- Top Navbar -->
      <div class="navbar navbar-transparent no-hairline">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <!-- <div class="left">
            <a href="#" class="link icon-only panel-open" data-panel="left">
              <i class="icon f7-icons if-not-md">menu</i>
              <i class="icon material-icons if-md">menu</i>
            </a>
          </div> -->
          <div class="left"><img src="static/images/RobotFX6.png" width="150px"/></div>
          <div class="right">
            <span style="color:rgb(255, 255, 255);font-size: 14px;" class="version">vX.XX</span>
            <!-- <a href="#" class="link icon-only panel-open" data-panel="right"> -->
            <a href="https://t.me/drpipsrobotfx" class="link icon-only external">
              <i class="icon f7-icons">quote_bubble</i>
              <!-- <i class="icon material-icons if-md">menu</i> -->
            </a>
          </div>
          <!-- <div class="title-large">s
            <div class="title-large-text"><img src="static/images/RobotFX6.png" width="150px"/></div>
            
          </div> -->
        </div>
      </div>
      
  <div class="page-content" style="background: linear-gradient(180deg, #121212 0%, #000000 100%);">
  <div class="control-size">    
  
    <div class="list block no-hairlines card-logout" style="margin-top: 15px;">
      <ul style="border-radius: 20px;background: linear-gradient(45deg, #28314d 0%, #151924 100%);">          
      <li>
        <div class="item-content">
          <div class="item-inner">
            <div class="item-title">        
              <div class="chip color-blue">
                <div class="chip-label">Account</div>
              </div>
            </div>
            <div class="item-after">
              <span style="color:darkgray;font-size: 12px;">EQUITY</span>
            </div>
          </div>
        </div>
      </li>
      <li>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title"><B><span class="DisplayName"></span></B><BR/><span class="AccountName text-dark"></span><span class="text-dark">/</span><span class="AccountNumber text-dark"></span><span class="text-dark"></span></div>
              <div class="item-after">
                <table style="width: 100%; text-align: right;">
                  <tr><td> <i class="icon f7-icons color-theme-blue" @click="${openUpdate}">square_pencil</i></td></tr>
                  
                </table>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div class="item-media">
              <img src="static/images/wallet.png" width="40px"/>
            </div>
            <div class="item-inner">
              <div class="item-title"><B><span class="AccountName"></span></B><BR/><span style="color:darkgray;font-size: 12px;" class="AccountLots"> </span></div>
              <div class="item-after">
                <table style="width: 100%; text-align: right;">
                  <tr><td><span style="color:rgb(121, 215, 255);font-size: 22px;" class="AccountBalanceOwn"></span> </td></tr>
                  <tr><td><span style="font-size:14px;color:gray" class="balance-myr"></span></td></tr>
                </table>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- <div class="card card-logout" style="border-radius: 10px; margin-bottom:35px;background-color: #151924;">
      <div class="card-content card-content-padding">
        <table width="100%">
          <td><span style="color:darkgray">Account</span></td>
          <td style="text-align: right;"><span style="color:darkgray">Equity Value</span></td>
        </table>

        <table width="100%">
          <td>STOCK | <span class="AccountName">Guest</span>
            <BR/><span style="color:darkgray"><span class="AccountLots"></span></span>
          </td>
          <td style="text-align: right;" >
            <span style="font-size: 18px;" class="AccountBalanceOwn"> $0.00 </span>
            <br/>
            <span style="font-size:14px;color:gray" class="balance-myr"></span>
          </td>
          
        </table>

      </div>
    </div> -->

    <div class="card card-logout" style="border-radius: 20px; margin-bottom:35px;background-color: #151924; margin-top: -20px;">
      <div class="card-content card-content-padding">        
        <table width="100%" style="text-align: center;">
          <!-- <td width="25%">
            <div @click="${()=>angryFlush('1')}">
              <p>
                <i class="icon f7-icons">plus_circle</i>
              </p>
              <span style="color:darkgray">Buy</span>
            </div> 
          </td> -->
          <!-- <td width="25%">
            <div @click="${()=>angryFlush('2')}">
            <p>
              <i class="icon f7-icons">minus_circle</i>
            </p>
            <span style="color:darkgray">Sell</span>
            </div>
          </td> -->
          <td width="33%">
            <a href="/stockbuy/" style="color: white;">
            <p>
              <span class="material-symbols-outlined">
                add_circle
                </span>
            </p>
            <span style="color:darkgray">Deposit</span>
            </a>
          </td>
          <td width="33%">
            <a href="/stocksell/" style="color: white;">
            <p>
              <span class="material-symbols-outlined" style="font-size: 24px;">
                do_not_disturb_on
              </span>
            </p>
            <span style="color:darkgray">Withdraw</span>
            </a>
          </td>
          <td width="33%">
            <a href="/transaction/" style="color: white;">
            <p>
              <span class="material-symbols-outlined" style="font-size: 24px;">
                receipt_long
              </span>
            </p>
            <span style="color:darkgray">Transaction</span>
            </a>
          </td>
          <!-- <td width="33%">
            <p>
              <i class="icon f7-icons">arrow_right_arrow_left_circle</i>
            </p>
            <span style="color:darkgray">Transaction</span>
          </td> -->
        </table>
      </div>
    </div>


    <div class="card card-new" style="border-radius: 10px;background-color: #151924; opacity: 0.9;">
      <div class="card-header card-header-big">NEW USER
        <span style="text-align:right ;">
          <i class="icon f7-icons color-theme-red" @click="${closeCreate}">multiply_circle</i>
        </span>
         
      </div>
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Name</div>
                  <div class="item-input-wrap">
                    <input type="text"  id='Name' placeholder="Your name"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">E-mail</div>
                  <div class="item-input-wrap">
                    <input type="email" id='Email' placeholder="E-mail"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Phone</div>
                  <div class="item-input-wrap">
                    <input type="tel" id='Phone' placeholder="Phone"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Password</div>
                  <div class="item-input-wrap">
                    <input type="password" id='Password' placeholder="Password"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <button class="button button-fill" @click=${createAccountOTP}>Create Account</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="card card-update" style="border-radius: 10px; background-color: #151924;">
      <div class="card-content card-content-padding no-hairlines card-header-big"> 
        <table width="100%">
          <tr>
            <td>
              SETTING
            </td>
            <td style="text-align: right;">
              <i class="icon f7-icons color-theme-red" @click="${closeUpdate}">multiply_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="card card-update" style="border-radius: 10px; background-color: #151924;">
      <!-- <div class="card-header card-header-big">CHANGE STOCK

      </div> -->
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Stock</div>
                <div class="item-input-wrap input-dropdown-wrap">
                  <select placeholder="Please choose..." id="change_stock">
                    <option value=""></option>
                  </select>
                </div>
              </div>
            </li>
            <li>
              <button class="button button-fill" @click=${change_stock}>Change</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="card card-update" style="border-radius: 10px; background-color: #151924;">
      <!-- <div class="card-header card-header-big">ACCOUNT INFORMATION
      </div> --> 
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Name</div>
                  <div class="item-input-wrap">
                    <input type="text"  id='UpdateName' placeholder="Your name"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">E-mail</div>
                  <div class="item-input-wrap">
                    <input type="email" id='UpdateEmail' placeholder="E-mail" disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Phone</div>
                  <div class="item-input-wrap">
                    <input type="tel" id='UpdatePhone' placeholder="Phone" disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Bank Name</div>
                  <div class="item-input-wrap">
                    <input type="text" id='UpdateBankName' placeholder="Bank Name"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Bank Account</div>
                  <div class="item-input-wrap">
                    <input type="text" id='UpdateBankAccount' placeholder="Bank Account"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <button class="button button-fill" @click=${updateAccount}>Update Account</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- <div class="card-login" style="text-align: center;">
      <br/><br/>
      <img src="static/images/RobotFX6.png" style="width: 50%;"/>
    </div> -->
    <div class="card card-login" style="border-radius: 10px; background-color: #151924; opacity: 0.9;">
      <!-- <div class="card-header card-header-big">USER LOGIN</div> -->
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Stock</div>
                <div class="item-input-wrap input-dropdown-wrap">
                  <select placeholder="Please choose..." id="select_stock">
                  </select>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Email</div>
                  <div class="item-input-wrap">
                    <input type="email" id='LoginEmail' placeholder="Email"/>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Password</div>
                  <div class="item-input-wrap">
                    <input type="password" id='LoginPassword' placeholder="Password"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <button class="button button-fill" @click=${login}>Login</button>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="card card-forgot" style="border-radius: 10px;background-color: #1519247e;">
      <div class="card-header card-header-big">CHANGE PASSWORD
        <span style="text-align:right ;">
          <i class="icon f7-icons color-theme-red" @click="${closeChange}">multiply_circle</i>
        </span>
      </div>
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Phone</div>
                  <div class="item-input-wrap">
                    <input type="tel" id='PhoneChange' placeholder="Phone"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">New Password</div>
                  <div class="item-input-wrap">
                    <input type="password" id='PasswordChange' placeholder="Password"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <button class="button button-fill" @click=${changePasswordOTP}>Request TAC</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
 
    <div class="list block no-hairlines card-login">
      <ul style="border-radius: 10px; background-color: #151924; opacity: 0.5;" >

        <li>
          <a href="#" class="item-link item-content" @click="${openCreate}">
            <div class="item-media"><i class="icon f7-icons">person_badge_plus</i></div>
            <div class="item-inner">
              <div class="item-title">Create Account</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
        <li>
          <a href="/plan/" class="item-link item-content">
            <div class="item-media"><i class="icon f7-icons">question_circle</i></div>
            <div class="item-inner">
              <div class="item-title">How To Use</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item-link item-content" @click="${openForgot}">
            <div class="item-media"><i class="icon f7-icons">number</i></div>
            <div class="item-inner">
              <div class="item-title">Forgot Password</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
        <li>
          <a href="https://octabot.net" class="item-link item-content external link" >
            <div class="item-media"><i class="icon f7-icons">cube</i></div>
            <div class="item-inner">
              <div class="item-title">About</div>
            </div>
          </a>
        </li>
      </ul>
    </div>



    <div class="list block no-hairlines card-logout" style="margin-top:0px; opacity: 0.5;">
      <ul style="border-radius: 10px; margin-bottom:35px;background-color: #151924; margin-top: -20px;">
        <li>
          <a href="/financialV2/" class="item-link item-content">
            <div class="item-media"><i class="icon f7-icons">doc_chart</i></div>
            <div class="item-inner">
              <div class="item-title">Financial Report</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
        <li>
          <a href="/plan/" class="item-link item-content">
            <div class="item-media"><i class="icon f7-icons">question_circle</i></div>
            <div class="item-inner">
              <div class="item-title">How To Use</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
        <li>
          <a href="https://t.me/drpipsrobotfx" class="item-link item-content external">
            <div class="item-media"><i class="icon f7-icons">antenna_radiowaves_left_right</i></div>
            <div class="item-inner">
              <div class="item-title">Channel</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
        <li>
          <a href="https://octabot.net" class="item-link item-content external link">
            <div class="item-media"><i class="icon f7-icons">cube</i></div>
            <div class="item-inner">
              <div class="item-title">About</div>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item-link item-content external" @click="${openUpdate}">
            <div class="item-media"><i class="icon f7-icons">gear_alt</i></div>
            <div class="item-inner">
              <div class="item-title">Setting</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item-link item-content" @click="${logout}">
            <div class="item-media"><i class="icon f7-icons">escape</i></div>
            <div class="item-inner">
              <div class="item-title">Logout</div>
              <!-- <div class="item-after">CEO</div> -->
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="block" style="font-size: smaller;color:rgb(255, 255, 255);text-align: center;">
      © 2022 - 2024 All rights reserved. RobotFX.
    </div>

  </div>
  </div>

  <div class="popup rfx-popup">
    <div class="page">
      <div class="page-content">
        
        

      </div>
    </div>
  </div>


</div>
`
    }
    ;
}

framework7Component.id = '6e017e9b10';
export default framework7Component;